import React from 'react';
import HeaderMain from '../../components/HeaderMain';

/**
 * Render the community page
 *
 * @component
 */
const Community = () => {
  return (
    <>
      <HeaderMain
        highlightTitle={'SORRY !'}
        subtitle={'Community page is under construction...'}
      />
    </>
  );
};

export default Community;
